export default __webpack_public_path__ + "static/live-seo-2011a5192e408efcf3f213cf0e10b5a9.webp";